export default __webpack_public_path__ + "static/media/VolvoNovum-Medium.2c36e957.woff2";